import { render, staticRenderFns } from "./talkPostList.vue?vue&type=template&id=1c70bd05&scoped=true&"
import script from "./talkPostList.vue?vue&type=script&lang=js&"
export * from "./talkPostList.vue?vue&type=script&lang=js&"
import style0 from "./talkPostList.vue?vue&type=style&index=0&id=1c70bd05&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c70bd05",
  null
  
)

export default component.exports